import { PackageActions } from "./components/package-actions";
import { PackageCancelPlan } from "./components/package-cancel-plan";
import { PackageCredit } from "./components/package-credit";
import { PackageDetailHeader } from "./components/package-detail-header";
import { PackageDetailInfo } from "./components/package-detail-info";
import { PackageLineItems } from "./components/package-line-items";
import { PackageRelatedVisits } from "./components/package-related-visits";
import { PackageDetailScreen } from "./package-detail.screen";

export { PackageSupportCard } from "./components/package-support-card";
export { PackageTerms } from "./components/package-terms";

export const PackageDetail = Object.assign(PackageDetailScreen, {
  Header: PackageDetailHeader,
  Info: PackageDetailInfo,
  RelatedVisits: PackageRelatedVisits,
  Items: PackageLineItems,
  Actions: PackageActions,
  Credit: PackageCredit,
  CancelPlan: PackageCancelPlan,
});
